import {injectable} from 'inversify';

import type {BaseModel} from './Base.model';

@injectable()
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class BaseController<Model extends BaseModel> {}
